<template>
  <div>
    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>

    <image-activity
      toolbar-title="Selfie"
      :tasks="tasks"
      :upload-to-mifos="uploadToMifos"
      :directory="directory"
      :entity-type="entityType"
      :entity-id="entityId"
      :attach-document-title="attachDocumentTitle"
      :attach-document-description="attachDocumentDescription"
      :image-activity-type="imageActivityType"
      :document-uploaded-title="documentUploadedTitle"
    ></image-activity>
  </div>
</template>

<script>
import ImageActivity from "./ImageActivity";
import { Constants } from "../../Constants";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import { Activities } from "../../../utils/ActivityNavigator";
import PrefManager from "../../../data/model/PrefManager";
import { RolesConstants } from "../../../utils/RolesConstants";

export default {
  name: "SelfieActivity",
  components: { ActivityRedirectItem, ImageActivity },
  data: () => ({}),

  computed: {
    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    /* activity-redirect-item props START*/
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PICTURE];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },
    /* activity-redirect-item props END*/

    /*Image screen props START*/
    uploadToMifos() {
      return Constants.UPLOAD;
    },

    directory() {
      return Constants.AVATAR;
    },

    entityType() {
      return Constants.CLIENTS;
    },

    entityId() {
      return LoanScopeDataHolder.getClientId();
    },

    attachDocumentTitle() {
      return this.isAgent ? "Please take a Customer's Selfie" : "Please take a Selfie";
    },

    attachDocumentDescription() {
      return "Please upload Live Photo with a clean white background, please do not take photo of photo.";
    },

    documentUploadedTitle() {
      return "Selfie Uploaded";
    },

    imageActivityType() {
      return Constants.SELFIE_IMAGE_ACTIVITY;
    }
    /*Image screen props END*/
  }
}
</script>

<style scoped></style>
